// pages/AboutPage.js
import React from 'react';

const AboutPage = () => {
  return (
    <div className="z-orange-watermark bg-white pt-36 pb-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-14">
          <span className="z-eyebrow">Tentang Kami</span>
          <h2 className="font-serif-display text-4xl md:text-5xl font-semibold mt-2 text-[var(--z-ink)]">About Us</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-6">
          <div className="z-card p-8">
            <h3 className="font-serif-display text-2xl font-semibold mb-3 text-[var(--z-accent)]">Our Mission</h3>
            <p className="text-[var(--z-muted)] leading-relaxed">To empower libraries and educational institutions with cutting-edge technology solutions.</p>
          </div>
          <div className="z-card p-8">
            <h3 className="font-serif-display text-2xl font-semibold mb-3 text-[var(--z-accent)]">Our Vision</h3>
            <p className="text-[var(--z-muted)] leading-relaxed">To be the leading provider of innovative library management systems and educational technology.</p>
          </div>
        </div>
        <div className="z-card p-8">
          <h3 className="font-serif-display text-2xl font-semibold mb-3 text-[var(--z-accent)]">Our History</h3>
          <p className="text-[var(--z-muted)] leading-relaxed">Founded in 2013, Your Company has been at the forefront of educational technology...</p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
